import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.552 8.13l3.11 1.795-10.083 5.82v4.314c0 .172.086.32.235.406l2.337 1.35a.23.23 0 00.235 0 .23.23 0 00.117-.204v-4.177l10.082-5.821 3.11 1.795c.298.172.47.468.47.813v5.395a10.185 10.185 0 00-2.63-.492v-.362c0-.394-.226-.747-.583-.914a1.005 1.005 0 00-1.074.14l-3.58 2.996a1.24 1.24 0 00-.447.998c.013.389.197.737.51.967l3.567 2.618c.308.226.712.259 1.053.086.341-.173.553-.517.553-.9v-.4c.743.09 1.478.318 2.081.755.118.084.229.177.332.276a.962.962 0 01-.252.208l-9.143 5.279a.917.917 0 01-.94 0L7.47 25.59A.917.917 0 017 24.78V14.22c0-.345.17-.64.47-.813l9.143-5.279a.917.917 0 01.939 0zm6.213 15.41c5.021 0 6.444 4.796 2.32 6.951a.048.048 0 00-.022.062c.01.022.033.033.056.028 6.851-1.686 6.372-10.712-2.354-10.712v-1.107a.236.236 0 00-.138-.218.235.235 0 00-.256.034l-3.58 2.996a.466.466 0 00-.171.384.466.466 0 00.196.372l3.567 2.617a.235.235 0 00.25.02.235.235 0 00.133-.214v-1.212z"
        fill="#333"
      />
    </Svg>
  );
}

export default SvgComponent;
